import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import ActivateUserPanelActions from './actions';

const initialState = Immutable({
  userId:        '',
  userEmail:     '',
  isSupportUser: false,

  avatar:     '',
  password:   '',
  repassword: '',
});

export default createReducer(on => {
  on(ActivateUserPanelActions.bootstrap, (state, { userId, userEmail, isSupportUser }) => {
    return state
      .set('userId', userId)
      .set('userEmail', userEmail)
      .set('isSupportUser', isSupportUser);
  });

  on(ActivateUserPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
